import $ from 'jquery';
import gsap from 'gsap';

let anchor = $('.anchor-link');

if (anchor) {

	anchor.on('click', function(e) {
		if (this.pathname == window.location.pathname &&
			this.protocol == window.location.protocol &&
			this.host == window.location.host) {
				e.preventDefault();

				gsap.to(window, {
					duration: 0.5,
					scrollTo: {
						y: e.target.hash,
						offsetY: 90
					}
				});
		}
	});

}
